// extracted by mini-css-extract-plugin
export default {"wrapper":"PageCard_wrapper__pwSx+","hasFixedFooter":"PageCard_hasFixedFooter__tnj2j"};